import React from 'react';
import { useNavigate } from 'react-router-dom';
import { markNotificationAsRead } from '../utils/notificationApi';
import {
  formatNotificationTime,
  getNotificationType,
} from '../utils/notificationApi';
import style from '../assets/style/NotificationItem.module.css';

const NotificationItem = ({ notification, onMarkAsRead, compact = false }) => {
  const navigate = useNavigate();

  const handleNotificationClick = async () => {
    try {
      // Mark as read if it's unread
      if (!notification.isRead) {
        await markNotificationAsRead(notification.notificationID);
        if (onMarkAsRead) {
          onMarkAsRead(notification.notificationID);
        }
      }

      // Navigate to the path if it exists
      if (notification.path) {
        navigate(notification.path);
      }
    } catch (error) {
      console.error('Error handling notification click:', error);
    }
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'like':
        return '❤️';
      case 'comment':
        return '💬';
      case 'post':
        return '📝';
      case 'summary':
        return '📊';
      case 'admin':
        return '🔧';
      case 'welcome':
        return '👋';
      default:
        return '🔔';
    }
  };

  const notificationType = getNotificationType(notification.message);
  const formattedTime = formatNotificationTime(notification.timestamp);

  return (
    <div
      className={`${style.notificationItem} ${
        !notification.isRead ? style.unread : style.read
      } ${compact ? style.compact : ''}`}
      onClick={handleNotificationClick}
    >
      <div className={style.notificationIcon}>
        {getNotificationIcon(notificationType)}
      </div>

      <div className={style.notificationContent}>
        <div className={style.notificationMessage}>{notification.message}</div>
        <div className={style.notificationTime}>{formattedTime}</div>
      </div>

      {!notification.isRead && <div className={style.unreadDot}></div>}
    </div>
  );
};

export default NotificationItem;
